import {
  PRINT_DISABLE_PRINT_MODE,
  PRINT_DISABLE_TABLE_MODE,
  PRINT_ENABLE_PRINT_MODE,
  PRINT_ENABLE_TABLE_MODE,
  PRINT_SET_PARAMS,
  PRINT_SET_PRINT_MODE,
  PRINT_SET_TABLE_MODE,
  PRINT_TOGGLE_PRINT_MODE,
  PRINT_TOGGLE_TABLE_MODE,
  PRINT_UPDATE_PARAMS
} from './types';

export const actions = {
  [PRINT_UPDATE_PARAMS]: ({ commit }, payload) => {
    commit(PRINT_SET_PARAMS, payload);
  },
  [PRINT_ENABLE_PRINT_MODE]: ({ commit }) => {
    commit(PRINT_SET_PRINT_MODE, true);
  },
  [PRINT_DISABLE_PRINT_MODE]: ({ commit }) => {
    commit(PRINT_SET_PRINT_MODE, false);
  },
  [PRINT_TOGGLE_PRINT_MODE]: ({ commit, state }) => {
    commit(PRINT_SET_PRINT_MODE, !state.printMode);
  },
  [PRINT_ENABLE_TABLE_MODE]: ({ commit }) => {
    commit(PRINT_SET_TABLE_MODE, true);
  },
  [PRINT_DISABLE_TABLE_MODE]: ({ commit }) => {
    commit(PRINT_SET_TABLE_MODE, false);
  },
  [PRINT_TOGGLE_TABLE_MODE]: ({ commit, state }) => {
    commit(PRINT_SET_TABLE_MODE, !state.tableMode);
  }
};
